// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4b7bafd6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/src/components/misc/Paginator.vue
// module id = 410
// module chunks = 0